import React from 'react';
import { EditOutlined, SearchOutlined , DeleteOutlined , PrinterOutlined} from "@ant-design/icons";
import {
  Row,
  Col,
  Button,
  Form,
  Input,
  Space,
  Table,
  Popover
} from "antd";

import { useState } from 'react';
import { useEffect } from 'react';
import enrollmentService from "../../../api/enrollment.service";
import { Link } from 'react-router-dom';
import { SUCCESS_STATUS } from "../../../utility/Constants";
import ProgrammeService from "../../../api/programme.service";
import CustomTableSearch from "../../common/CustomTableSearch";
import commonUtility from "../../../utility/Utils";
import { PRINT_BASE_URL } from '../../../utility/URL';


const HpMonthlyReminderListView = ({jcpMonthlyUnPaidList}) => {

  const [paymentMonths,setPaymentMonths] = useState([]);

  const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} items`;
  const [page, setPage] = React.useState(1);


  const showMonths = (receipt_master_id) => {
    const data = {
      formdata: { receipt_master_id: receipt_master_id },
    };
    ProgrammeService.paymentMonthByReceipt(data).then((res) => {
      console.log("responseHp", res);
      if (res.data.response_status === SUCCESS_STATUS) {
          setPaymentMonths(monthView(res.data.response_data));
          
      }
    });

  }

  const monthView = (months) => {

    return months.map((data) => {
      return (
        <div><p>{data.short_name} - {data.year}</p></div>
      )
    })

}


  const columns = [
    { 
      title: '#', 
      dataIndex: 'index', 
      render: (text, record, index) => (page - 1) * 10 + ++index ,
      width: '5%',
    },
    {
        title: 'Name',
        dataIndex: 'member_fname',
        key: 'member_fname',
        render: (selectedObj,render) => (
               <>
                {render.masterData.member_fname} {render.masterData.member_lname}
               </>
                
            
        )
  
      },
      {
        title: 'Mobile No',
        dataIndex: 'primary_mobile',
        key: 'primary_mobile',
        render: (selectedObj,render) => (
          <>
           {render.masterData.primary_mobile} 
          </>
           
       
   )
  
      },
   
    {
        title: 'Father Name',
        dataIndex: 'father_name',
        key: 'father_name',
        render: (selectedObj,render) => (
          <>
           {render.masterData.father_name} 
          </>
           
       
   )
  
      },

      {
        title: 'Group/Shift',
        dataIndex: 'programme_group',
        key: 'programme_group',
        render: (selectedObj,render) => (
               <>
                {render.masterData.programme_group} 
               </>
                
            
        )
  
      },

    {
        title: 'Validity',
        dataIndex: 'enrollment_start_date',
        key: 'enrollment_start_date',
        render: (selectedObj,render) => (
           <div style={{fontWeight:'bold',fontStyle:'italic'}}>{commonUtility.formatStringDate(render.masterData.enrollment_start_date)} to {commonUtility.formatStringDate(render.masterData.enrollment_end_date)}</div>
        )
      },
    
      {
        title: 'Paid Desc',
        dataIndex: 'address_one',
        key: 'address_one',
        render: (selectedObj,render) => (
          <>
            {
              render.detailsData.receipt_dtl_id > 0 ? <>
              <p style={{margin:0}}>Receipt No : {render.detailsData.receipt_no} </p>
              <p style={{margin:0}}>Receipt Date : {commonUtility.formatStringDate(render.detailsData.receipt_date)} </p>
              <h4>No of Months : &nbsp;
                {/* <span onClick={()=>showMonths(render.detailsData.receipt_master_id)}>{render.detailsData.no_of_months} </span> */}
                <Popover content={paymentMonths} title="Months" trigger="click" onClick={()=>showMonths(render.detailsData.receipt_master_id)}>
                  <Button type="dashed" danger shape="circle" >{render.detailsData.no_of_months}</Button>
                </Popover>
                </h4>
              </> : ''
              
            }
          </>
       )
      },
    
    {
      title: 'Action',
      key: 'action',
      render: (selectedObj,render) => (
        <Space size="middle">
              {
                render.detailsData.receipt_dtl_id > 0 ? <>
                  <>
                  <Space style={{display:'flex',flexDirection:'column'}}>
                    <Button type="primary" shape='round' size='small' className='custom-button-green' style={{width:90}} >Paid </Button>
                    
                    <Link to={ render.detailsData.entry_from == "A" ?  `/high-performance/${render.detailsData.enrollment_id}/${render.detailsData.receipt_id}/${render.detailsData.payment_id}` : `/hp-monthly/${render.detailsData.is_gst_bill == "Y" ? "gst" : "nongst" }/${render.detailsData.enrollment_id}/${render.detailsData.receipt_id}/${render.detailsData.payment_id}`} >
                      <Button htmlType="button" type="ghost" size="small" shape="round" style={{width:90}}  >Edit <EditOutlined /></Button>
                    </Link>
                    {/* <Button type="danger"  shape='circle' icon={<DeleteOutlined />} /> */}

                      <a href={`${PRINT_BASE_URL}taxinvoice/receiptpdf/${render.detailsData.enrollment_id}/${render.detailsData.receipt_id}/${render.detailsData.payment_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0 }`} target="_blank" rel="noopener noreferrer">
                        <Button htmlType="button" type="ghost" size="small" shape="round"  style={{width:90}} ><PrinterOutlined /> Print</Button>
                      </a>

                    </Space>
                    
                    
    
                  </>
                </> : <>
                  <Link to={`/hp-monthly/${render.detailsData.is_gst_bill == "Y" ? "gst" : "nongst" }/${render.masterData.member_id}`} >
                    <Button type="danger" shape='round' size='small' style={{width:90}} >Pay Now</Button>
                  </Link>
                  
                </>
              }
             
        </Space>
      ),
    },

  ];



  




  return (
    <>

      {/* <CustomTableSearch onSearchTable={onSearch} /> */}
      <Table 
      columns={columns} 
      rowKey='member_id' 
      dataSource={jcpMonthlyUnPaidList} 
      pagination={{
          showTotal,
          onChange(current) {
            setPage(current);
          }
        }}
      size="small"
      
      />

    </>
  );
};

export default HpMonthlyReminderListView;